import React from 'react'
import AisleHeatmappingImageRenderer from './AisleHeatmapImageRenderer'

export default {
  install( molten ) {
    molten.addPlugin( 'AttributeValueRenderer', {
      objectType : 'aisle',
      attrName : 'aisle.image',
      renderer : ( value, valueStyle, object, _context ) => {

        return React.createElement( AisleHeatmappingImageRenderer, {
          value : Array.isArray( value ) ? value[0] : null,
          object,
          style : valueStyle
        } )
      }
    } )
  }
}
